import { render, staticRenderFns } from "./CourseProvider.vue?vue&type=template&id=3b0b23d6&"
import script from "./CourseProvider.vue?vue&type=script&lang=js&"
export * from "./CourseProvider.vue?vue&type=script&lang=js&"
import style0 from "./CourseProvider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports